import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EditorStyle, QuillConfig } from 'src/app/constants/app.constants';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-comment-section',
  templateUrl: './comment-section.component.html',
  styleUrls: ['./comment-section.component.scss'],
})
export class CommentSectionComponent implements OnInit {
  @Input() comment: string;
  @Input() isDetailsView: boolean;
  @Input() isExternalUser: boolean;
  @Input() orderProcess$: Observable<any>;
  @Input() editableStatuses: Array<number>;

  @Output() commentChange = new EventEmitter<string>();

  canEdit$: Observable<boolean>;

  editorStyle = EditorStyle;
  quillConfig = QuillConfig;

  constructor() {}

  ngOnInit(): void {
    this.canEdit$ = this.getCanEdit();
  }

  private getCanEdit(): Observable<boolean> {
    if (!this.isExternalUser) {
      return of(false);
    }

    if (!this.isDetailsView) {
      return of(true);
    }

    return this.orderProcess$.pipe(map(orderProcess => this.isInEditableStatus(orderProcess.status)));
  }

  private isInEditableStatus(status: number) {
    return this.editableStatuses.includes(status);
  }
}
